import React, { Component } from "react";
import { Table, Button } from "antd";
import { PlusOutlined, PrinterOutlined } from "@ant-design/icons";
import moment from "moment";

import { AddUserPermission } from "./add-user-permission";
import { apiCustomer } from "../../../api/api-customer";
import { emitter } from "../../../common/utils/emitter";
import { alert } from "../../../common/utils/alert";
import { Tabs } from "./tab";
import { RangeDetail } from "./range-detail/range-detail-table";

export class UserPermissionTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      total: 0,
      isAddUser: false,
      typeOption: "create_new",
      exportFilter: {
        customer_name: null,
        admin_name: null,
        created_at: null,
        created_by: null,
        tax_code: null,
        address: null,
      },
      tab: "listRole",
    };

    this.page = 1;

    this.customerTable = [
      {
        title: "STT",
        dataIndex: "index",
        key: "index",
        maxWidth: 60,
      },
      {
        title: "Tên vai trò",
        dataIndex: "customer_name",
        key: "customer_name",
        render: (name) => (
          <div style={{ minWidth: 200, maxWidth: 250, textAlign: "left" }}>
            {name}
          </div>
        ),
      },
      {
        title: "Người tạo",
        dataIndex: "data",
        key: "code",
        render: (data) => (
          <div style={{ textAlign: "right" }}>
            {data.id_card ? data.id_card : data.tax_code}
          </div>
        ),
      },
      {
        title: "Ngày tạo",
        dataIndex: "address",
        key: "address",
        render: (name) => (
          <div style={{ minWidth: 200, maxWidth: 250, textAlign: "left" }}>
            {name}
          </div>
        ),
      },
      {
        title: "Chi tiết",
        dataIndex: "data",
        key: "id",
        render: (data) => (
          <div style={{ minWidth: 60 }} onClick={() => this.showDetail(data)}>
            <img
              alt=""
              className="detail-icon"
              src={require("../../../assets/icons/info-circle-solid.png")}
            />
          </div>
        ),
      },
    ];
  }

  componentDidMount() {
    this.getData(1);
  }

  showDetail = (data) => {
    this.handleAddUser(true, "show_detail", data);
  };

  handleAddUser = (status, type, data) => {
    this.setState({ isAddUser: status, typeOption: type }, () => {
      const element = document.getElementById("right-layout");
      element.scrollTo(0, 0);
      if (data) {
        this.addUserPermission.updateFormUserPermission(data);
      }
      if (!status) {
        this.getData(1);
      }
    });
  };

  getData = async (page) => {
    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }

    try {
      emitter.emit("FETCH_LOADING", true);
      const result = await apiCustomer.getCustomers(
        this.state.exportFilter,
        page
      );
      emitter.emit("FETCH_LOADING", false);
      if (result.status === "success") {
        const dataConvert = result.data.content.map((value, index) => {
          return {
            index: index + (page - 1) * 10 + 1,
            ...value,
            data: value,
          };
        });
        this.setState(
          { dataTable: dataConvert, total: result.data.total_elements },
          () => {}
        );
      }
    } catch (error) {
      emitter.emit("FETCH_LOADING", false);
    }
  };

  onChangePage = (page) => {
    const element = document.getElementById("right-layout");
    element.scrollTo(0, 0);
    this.getData(page, false);
  };

  onChangeTab = (tab) => {
    this.setState({ tab, isAddUser: false }, () => {
      if (tab === "listRole") {
        this.setState({
          exportFilter: {
            //nhớ sửa cái này nhé hihi
            customer_name: "",
          },
        });
        this.getData(1);
      }
    });
  };

  render() {
    const { dataTable, total, isAddUser, typeOption, tab } = this.state;
    return (
      <div className="contract-table">
        <Tabs onChangeTab={this.onChangeTab} />
        {tab !== "listRole" ? (
          <RangeDetail />
        ) : !isAddUser ? (
          <>
            {" "}
            <Table
              rowKey={(record) => record.customer_id}
              style={{ width: "100%", marginTop: 20 }}
              dataSource={dataTable}
              pagination={{
                total,
                pageSize: 10,
                onChange: this.onChangePage,
                current: this.page,
              }}
              //pagination={false}
              scroll={{ x: true }}
              columns={this.customerTable}
            />
            <div className="button-container">
              <Button
                onClick={() => this.handleAddUser(true, "create_new")}
                className="add-btn"
              >
                <PlusOutlined /> Thêm vai trò
              </Button>
            </div>{" "}
          </>
        ) : (
          <AddUserPermission
            typeOption={typeOption}
            ref={(ref) => (this.addUserPermission = ref)}
            close={() => this.handleAddUser(false)}
          />
        )}
      </div>
    );
  }
}
